// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ReserveActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import Reserve from '../components/Reserve';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingFlight: state.reserve.isFetchingFlight,
    flight: state.reserve.flight,
    fetchFlightError: state.reserve.fetchFlightError,
    isFetchingOrder: state.reserve.isFetchingOrder,
    order: state.reserve.order,
    fetchOrderError: state.reserve.fetchOrderError,
    isPostingReserve: state.reserve.isPostingReserve,
    postReserveError: state.reserve.postReserveError,
    isPostingPhone: state.reserve.isPostingPhone,
    user: state.auth.user,
    postPhoneError: state.reserve.postPhoneError,
    editSuccessful: state.reserve.editSuccessful,
    localValues: state.localValues,
    locale: state.locale,
    motives: state.report.motives,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...ReserveActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Reserve);



// WEBPACK FOOTER //
// ./src/modules/reserve/containers/ReserveContainer.js